import React from 'react';

import ResultsPerPageContainer from './ResultsPerPage';
import PaginationContainer from './Pagination';

import './ResultsPagination.scss';

function ResultsPagination() {
  return (
    <nav
      className="results-pagination align-items-center u-els-display-flex u-els-margin-top-1x1o2 u-els-margin-bottom-4x u-els-padding-left-2x"
      data-e2e="e2e-results-pagination"
      aria-label="Page navigation">
      <ResultsPerPageContainer />
      <PaginationContainer />
    </nav>
  );
}

export default ResultsPagination;
